import React from 'react'

const CaptionEditorComponent = (props: any) => {
  const key = props['data-offset-key'].split('-')[0];

  return (
    <div id={key}>{props.children}</div>
  )
}

export default CaptionEditorComponent
